// extracted by mini-css-extract-plugin
export default {"container":"main_container__k8twq","header":"main_header__CmB3+","headerAccent":"main_headerAccent__FEdCP"};